// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import './api/firebaseInit';
import {
  store
} from './api/store';
//import VueFire from 'vuefire';
import Vuex from 'vuex';
import WebrtcAdapter from 'webrtc-adapter';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';
import firebase from 'firebase';
// naz depencies
// import * as Sentry from '@sentry/browser'
//import JsonExcel from 'json-to-excel';
import JsonExcel from 'vue-json-excel'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueLazyload from 'vue-lazyload'
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import VueQRCodeComponent from 'vue-qrcode-component' 
import Multiselect from 'vue-multiselect'
import { auth } from '@/api/firebaseInit';

import axios from 'axios'
import VueAxios from 'vue-axios'
import Geocoder from "@pderas/vue2-geocoder";
import store_lang from './store'
import './i18n'

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueInstantSearch from 'vue-instantsearch';
Vue.use(VueInstantSearch);

Vue.use(Datetime)


Vue.use(Geocoder, {
    googleMapsApiKey: 'AIzaSyDYC5J8ABVqS5g1UUt3BsXmw3KnTgaM6Qk'
});
Vue.use(VueAxios, axios)

require('vue-multiselect/dist/vue-multiselect.min.css')

// register globally
Vue.component('multiselect', Multiselect)
/* const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
 */
Vue.config.productionTip = false;
// Helpers
// Global filters
//Vue.use(require('vue-moment'));
Vue.use(DatetimePicker)
Vue.use(VueLazyload)
Vue.component('downloadExcel', JsonExcel)
Vue.use(Viewer)
//Vue.use(VueFire);
Vue.use(WebrtcAdapter);
Vue.use(Vuex);
Vue.use(firebase);

// Register the Vue component
Vue.component('qr-code', VueQRCodeComponent) 

Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields'
});
Vue.use(Vuetify, {
  // theme: {
  //   primary: colors.indigo.base, // #E53935
  //   secondary: colors.indigo.lighten4, // #FFCDD2
  //   accent: colors.indigo.base // #3F51B5
  // },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  }
});
// Bootstrap application components

//Prod var
const isProd = process.env.NODE_ENV === 'production'
let app;
/* eslint-disable no-new */

firebase.auth().onAuthStateChanged(async user => {
  if (!app) {
    if (user) {
     // console.log("sucess",JSON.stringify(user))
      await store.dispatch('fetchChangedSigninUserInfo')
    } else {
     // console.log("not loginIn sucess")
      await  store.dispatch('Logout_main');
    }
    app = new Vue({
      el: '#app',
      router,
      store,
      store_lang,
      components: {
        App
      },
      template: '<App/>'
    });
 /*    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app"); */
  }
});

/* new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
}); */

/* if (!isProd) {
  Sentry.init({
    dsn: 'https://1c79f64a8767498190376989ca7e78ea@sentry.io/1366181',
    integrations: [new Sentry.Integrations.Vue({
      Vue
    })],
    environment: process.env.NODE_ENV,
    release: "alpha 1.0.0",
    // debug: !isProd,
    beforeSend(event) {
      // Check if it is in prod, if so, send to the server
      if (!isProd) {
        return event
      } else {
        return null
      }
    }
  })
} */


// WEBPACK FOOTER //
// ./src/main.js